import { inject, injectable } from "inversify";
import { IStorageService } from "../models/IStorageService";
import { Types } from "../../../ioc/types";
import { IHttpClientService } from "../../http/models/IHttpClientService";
import {
  BalanceRequest,
  CreateSchedule,
  ResponseBalanceData,
  ResponseBalanceSummaryData,
  ResponseUnloadData,
  Row,
  ScheduleList,
} from "../models/storage-dto";

@injectable()
export class StorageService implements IStorageService {
  @inject(Types.IHttpService)
  private readonly httpInstance!: IHttpClientService;

  public async getListUnload(
    endpoint: "unload" | "retrieval",
    data: ScheduleList
  ): Promise<ResponseUnloadData> {
    return await this.httpInstance.get(`/ms-contracts/marine-${endpoint}`, {
      params: {
        ...data,
      },
    });
  }

  public async createSchedule(
    endpoint: "unload" | "retrieval",
    data: CreateSchedule
  ): Promise<void> {
    return await this.httpInstance.post(
      `/ms-contracts/marine-${endpoint}`,
      data
    );
  }

  public async updateSchedule(
    id: string,
    endpoint: "unload" | "retrieval",
    data: { volumeRequested: number; note?: string }
  ): Promise<void> {
    return await this.httpInstance.patch(
      `/ms-contracts/marine-${endpoint}/${id}`,
      data
    );
  }

  public async updateUnloadCustomer(
    id: string,
    data: { volumeRequested: number; note?: string }
  ): Promise<void> {
    return await this.httpInstance.patch(
      `/ms-contracts/marine-unload/${id}/customer-update`,
      data
    );
  }

  public async updateRetrievalCustomer(
    id: string,
    data: { volumeRequested: number; note?: string }
  ): Promise<void> {
    return await this.httpInstance.patch(
      `/ms-contracts/marine-retrieval/${id}`,
      data
    );
  }

  public async getScheduleById(
    id: string,
    endpoint: "unload" | "retrieval"
  ): Promise<Row> {
    return await this.httpInstance.get(
      `/ms-contracts/marine-${endpoint}/${id}`
    );
  }

  public async getStorageBalance(
    data: BalanceRequest
  ): Promise<ResponseBalanceData> {
    const response = await this.httpInstance.get<ResponseBalanceData>(
      `/ms-contracts/storage-balance`,
      { params: data }
    );

    return response;
  }

  public async getStorageBalanceSummary(
    data: BalanceRequest
  ): Promise<ResponseBalanceSummaryData> {
    const response = await this.httpInstance.get<ResponseBalanceSummaryData>(
      `/ms-contracts/storage-balance/summary`,
      { params: data }
    );

    return response;
  }

  public async getNfsByContract(contractId: string): Promise<string[]> {
    const response = await this.httpInstance.get<string[]>(
      `/ms-contracts/marine-unload/nfs-by-contract`,
      { params: { contractId } }
    );

    return response;
  }

  public async downloadReport(endpoint: "unload" | "retrieval"): Promise<Blob> {
    return await this.httpInstance.get(
      `/ms-contracts/marine-${endpoint}/report`,
      {
        responseType: "blob",
      }
    );
  }
}
